import { render, staticRenderFns } from "./KnowledgeBaseIndex.vue?vue&type=template&id=da386878"
import script from "./KnowledgeBaseIndex.vue?vue&type=script&lang=js"
export * from "./KnowledgeBaseIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports